export default __webpack_public_path__ + "static/media/woman.6d9650b8.png";